"use client";

import { ArrowRight } from "@phosphor-icons/react";
import Link from "next/link";
import Image from "next/image";

const getCoursePath = (course) => {
  const id = course?.id || course?._id || course?.course_id || course?.slug;
  return id ? `/courses/${id}` : null;
};

const getFullSignupPath = (course) => {
  const id = course?.id || course?._id || course?.course_id || course?.slug;
  return id ? `/register/full?course_id=${id}` : "/register/full";
};

const ReusableCardComp = ({
  title,
  price,
  discount_price,
  essential_features,
  cover_image,
  showEnrollButton,
  id,
  _id,
  course_id,
  slug,
}) => {
  const coursePath = getCoursePath({ id, _id, course_id, slug });
  const fullSignupPath = getFullSignupPath({ id, _id, course_id, slug });
  const displayPrice = discount_price ?? price;
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden flex flex-col w-full sm:max-w-sm">
      <div className="relative w-full h-[189px]">
        {cover_image ? (
          <Image
            src={cover_image}
            alt={title}
            fill
            sizes="(max-width: 640px) 100vw, 380px"
            className="absolute inset-0 h-full w-full object-cover"
          />
        ) : (
          <div className="h-full w-full bg-gray-200 rounded-lg flex items-center justify-center">
            <span>{title}</span>
          </div>
        )}
        {displayPrice && (
          <div className="absolute bottom-[-12px] right-2 bg-[#08448F] text-white text-[16px] px-[8px] py-[4px] rounded-full font-semibold">
            ₹ {Number(displayPrice).toLocaleString("en-IN")}
          </div>
        )}
      </div>

      <div className="py-[32px] px-[16px] flex flex-col justify-between h-full">
        <div className="flex flex-col gap-[16px]">
          <h3 className="text-[21px] font-600">{title}</h3>

          <ul className="text-[16px] font-[400] text-[#484848] space-y-[16px] list-none">
            {(essential_features || "")
              .split("\n")
              .filter((point) => point.trim() !== "")
              .slice(0,3)
              .map((point, index) => (
                <li key={index}>{point.replace(/^- /, "")}</li>
              ))}
          </ul>
        </div>

        <div className="flex gap-[16px]">
          {showEnrollButton && (
            <Link
              href={fullSignupPath}
              className="flex-1 bg-[#0D6FEA] hover:bg-[#08448F] text-white text-sm rounded-[4px] px-[16px] py-[8px] cursor-pointer text-center"
            >
              BUY FULL COURSE
            </Link>
          )}
          {coursePath ? (
            <Link
              href={coursePath}
              className="flex-1 text-[#0D6FEA] hover:text-[#08448F] text-sm flex items-center justify-center gap-[8px] px-[16px] py-[8px] cursor-pointer"
            >
              VIEW DETAILS <ArrowRight size={24} />
            </Link>
          ) : (
            <button
              className="flex-1 text-[#0D6FEA] text-sm flex items-center justify-center gap-[8px] px-[16px] py-[8px] opacity-50 cursor-not-allowed"
              disabled
            >
              VIEW DETAILS <ArrowRight size={24} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReusableCardComp;
